import { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { servicesService } from "/app/src/services";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { StatusType } from "/app/src/contexts/types";
import { Button, useDisclosure, Modal } from "@heroui/react";
import RedButton from "/app/src/components/HeroUi/RedButton";
import ModalBuilder from "/app/src/components/HeroUi/helpers/ModalBuilder";
import { IconBuilder } from "/app/src/components/icons/IconBuilder";

/**
 * Component for displaying restart button
 * @returns JSX.Element
 *
 */
export default function RestartButton() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const [isLoading, setIsLoading] = useState(false);

  /**
   * Ok handler for modal
   */
  const handleOk = useCallback(() => {
    setIsLoading(true);
    servicesService.restart().then(() => {
      queryClient.setQueryData(["status"], (oldData: StatusType) => {
        return {
          ...oldData,
          message: "restarting",
        };
      });
      navigate("/status/restart");
      //navigate
    });
  }, [navigate, queryClient, setIsLoading]);

  return (
    <>
      <Button
        color="default"
        variant="bordered"
        radius="sm"
        size="sm"
        onPress={onOpen}
      >
        <IconBuilder icon="Restart" color="#000000" size={16} />
        {t("translation:restart_itempath")}
      </Button>
      <Modal
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement="top"
        aria-label="Confirm restart"
      >
        {ModalBuilder({
          warning: true,
          modalHeader: t("translation:restart_itempath"),
          modalBody: t("translation:confirm_restart"),
          modalFooter: (
            <>
              <Button
                size="sm"
                radius="none"
                color="default"
                variant="bordered"
                onPress={onOpenChange}
              >
                {t("translation:cancel")}
              </Button>
              <RedButton
                radius="none"
                size="sm"
                onPress={handleOk}
                isLoading={isLoading}
              >
                {t("translation:restart")}
              </RedButton>
            </>
          ),
        })}
      </Modal>
    </>
  );
}
